import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrophy, faCalendarCheck, faCode, faGem } from '@fortawesome/free-solid-svg-icons';
import './ClassStats.css';

/* Top of a student's classes (My Classes, and the Classes of a student profile for admin + teacher):
   row 1: overall progress, alone
   row 2: classes taken · Standard sessions · Mastery sessions (taken / paid, and not scheduled yet) */
export const TypeCard = ({ kind, label, icon, x, now, hidePaid = false }) => {
  if (!x) return null;
  // teachers: how many classes of this kind were taken, nothing about payments
  if (hidePaid) {
    return (
      <div className={`rmcs-card is-${kind}`}>
        <div className="rmcs-top">
          <span className="rmcs-icon">
            <FontAwesomeIcon icon={icon} />
          </span>
          <span className="rmcs-label">{label}</span>
          {now && <i className="rmcs-now">Now</i>}
        </div>
        <strong className="rmcs-num">{x.taken}</strong>
        <span className="rmcs-sub">{x.taken === 1 ? 'class taken' : 'classes taken'}</span>
      </div>
    );
  }
  const pct = x.bought > 0 ? Math.min(100, Math.round((x.taken / x.bought) * 100)) : 0;
  return (
    <div className={`rmcs-card is-${kind} ${x.left < 0 ? 'is-over' : ''}`}>
      <div className="rmcs-top">
        <span className="rmcs-icon">
          <FontAwesomeIcon icon={icon} />
        </span>
        <span className="rmcs-label">{label}</span>
        {now && <i className="rmcs-now">Now</i>}
      </div>
      <strong className="rmcs-num">
        {x.taken}
        <small>/{x.bought}</small>
      </strong>
      <span className="rmcs-bar" aria-hidden="true">
        <span style={{ width: `${pct}%` }} />
      </span>
      <span className="rmcs-sub">
        {x.bought === 0 && x.taken === 0
          ? 'No sessions paid'
          : x.left < 0
          ? `${-x.left} not paid`
          : x.left === 0
          ? 'All scheduled'
          : `${x.left} to schedule`}
      </span>
    </div>
  );
};

const ClassStats = ({ percent, lessonsDone, lessonsTotal, classesTaken, classesTotal, sessionTypes, hidePaid = false }) => {
  const st = sessionTypes?.ready ? sessionTypes : null;
  const classesPct = classesTotal > 0 ? Math.min(100, Math.round((classesTaken / classesTotal) * 100)) : 0;
  return (
    <div className="rmcs">
      <div className="rmcs-overall">
        <span className="rmcs-icon">
          <FontAwesomeIcon icon={faTrophy} />
        </span>
        <div className="rmcs-overall-main">
          <div className="rmcs-overall-head">
            <strong>{percent}%</strong>
            <span>overall progress</span>
            <em>
              {lessonsDone} of {lessonsTotal} lessons
            </em>
          </div>
          <span className="rmcs-bar rmcs-bar--big" aria-hidden="true">
            <span style={{ width: `${percent}%` }} />
          </span>
        </div>
      </div>

      <div className={`rmcs-row ${st ? '' : 'is-one'}`}>
        <div className="rmcs-card is-classes">
          <div className="rmcs-top">
            <span className="rmcs-icon">
              <FontAwesomeIcon icon={faCalendarCheck} />
            </span>
            <span className="rmcs-label">Classes taken</span>
          </div>
          <strong className="rmcs-num">
            {classesTaken}
            <small>/{classesTotal}</small>
          </strong>
          <span className="rmcs-bar" aria-hidden="true">
            <span style={{ width: `${classesPct}%` }} />
          </span>
          <span className="rmcs-sub">
            {classesTotal - classesTaken > 0 ? `${classesTotal - classesTaken} coming up` : 'No classes coming up'}
          </span>
        </div>
        {st && (
          <>
            <TypeCard kind="standard" label="Standard sessions" icon={faCode} x={st.types.standard} now={st.classType === 'standard'} hidePaid={hidePaid} />
            <TypeCard kind="mastery" label="Mastery sessions" icon={faGem} x={st.types.mastery} now={st.classType === 'mastery'} hidePaid={hidePaid} />
          </>
        )}
      </div>
    </div>
  );
};

/* just the two paid-sessions cards (My Schedule) */
export const SessionTypeRow = ({ sessionTypes }) => {
  const st = sessionTypes?.ready ? sessionTypes : null;
  if (!st) return null;
  return (
    <div className="rmcs rmcs--row-only">
      <div className="rmcs-row is-two">
        <TypeCard kind="standard" label="Standard sessions" icon={faCode} x={st.types.standard} now={st.classType === 'standard'} />
        <TypeCard kind="mastery" label="Mastery sessions" icon={faGem} x={st.types.mastery} now={st.classType === 'mastery'} />
      </div>
    </div>
  );
};

export default ClassStats;
